module.exports = __webpack_public_path__ + "static/media/animal.1a288700.png";